import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSingleAppAction = createAsyncThunk(
    'get-single-app-details',
    async (data, { rejectWithValue }) => {
        console.log("data---->",data)
        try {
            const res = await axios.get(`/admins/api/single-app-detail/${data}`) 
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleAppSlice = createSlice({
    name: 'get-single-publisher-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleAppAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleAppAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSingleAppAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSingleAppReducer = getSingleAppSlice.reducer